module.exports = __webpack_public_path__ + "img/videobgc7.86a3e33f.png";